function tab(event, keysPressed) {
  // note: ctrl + tab is reserved by browser
  
  if (event.key == 'Tab') {
    event.preventDefault();
    console.log("Tab");

    if (!keysPressed['Shift']) {
      document.execCommand("indent", false);
    }
  }

  if (keysPressed['Shift'] && event.key == 'Tab') {
    event.preventDefault();
    console.log("Shift+Tab");
    document.execCommand("outdent", false);
  }
}

export { tab }